var React = require('react');

function CheckIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M18.19,4.89a2.22,2.22,0,0,1,3.36,2.9L21.36,8,10.48,19.11a2.24,2.24,0,0,1-3,.19l-.21-.19L2.64,14.35a2.22,2.22,0,0,1,3-3.3l.21.19,3.08,3.14Z"}));
}

CheckIcon.defaultProps = {"data-dmid":"dm-check","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = CheckIcon;

CheckIcon.default = CheckIcon;
